import { TcrLayout } from "@/tcr/TcrLayout";
import { StatusChip, Kicker } from "@/tcr/ui";
import { DIAG_CHECKS } from "@/tcr/data";

export default function TcrDiagnostics() {
    return (
        <TcrLayout>
            <Kicker>Diagnostics · synthetic status</Kicker>
            <h1 className="mt-3 text-3xl font-medium tracking-tight text-slate-900">
                Demonstrator diagnostics
            </h1>
            <p className="mt-3 max-w-3xl text-sm leading-relaxed text-slate-600">
                Synthetic status view for the deterministic demonstrator. No
                implementation secrets, credentials, tokens or private algorithms are
                exposed here.
            </p>

            <div className="mt-8 divide-y divide-slate-100 overflow-hidden rounded-sm border border-slate-200 bg-white" data-testid="diagnostics-checks">
                {DIAG_CHECKS.map(([label, detail, state]) => (
                    <div key={label} className="flex flex-col gap-1 px-6 py-3.5 sm:flex-row sm:items-center sm:justify-between" data-testid={`diag-${label.toLowerCase().replace(/\s/g, "-")}`}>
                        <div>
                            <p className="text-sm font-medium text-slate-900">{label}</p>
                            <p className="mt-0.5 font-mono text-xs text-slate-500">{detail}</p>
                        </div>
                        <StatusChip tone={state === "pass" ? "green" : "slate"}>
                            {state === "pass" ? "OK" : "DISABLED"}
                        </StatusChip>
                    </div>
                ))}
            </div>

            <p className="mt-5 text-xs leading-relaxed text-slate-500" data-testid="diagnostics-note">
                Default mode is SIMULATED. Live mode is represented visually but remains
                disabled — no bearer token is requested or embedded, and no
                browser-accessible credentials exist in this build.
            </p>
        </TcrLayout>
    );
}
